export default __webpack_public_path__ + "static/media/Bandit's Belt of the Bloody Fang.332d7a37.jpg";